import { atom } from 'recoil';
import {
  MODAL_TRIGGER,
  PRIVACY_MODAL,
  PL_COMMIT,
  QUARTERLY_OP_DETAILS,
  QUARTER_INFO,
  GCSP_QUARTER_INFO,
  YEAR_WISE_DATA,
  PL_OPPS_DETAILS_MODAL,
  GCSP_OPPS_DETAILS_MODAL,
  PL_COMMENT_MODAL,
  GCSP_COMMENT_MODAL,
  PL_OPPS_NAME_DETAILS_WARNING_MODAL,
  GCSP_OPPS_DETAILS_WARNING_MODAL,
  PL_COMMENT_WARNING_MODAL,
  GCSP_COMMENT_WARNING_MODAL,
  PL_SUBMIT_SUCCESS_MODAL,
  PL_FAILURE_CONFIRMATION_MODAL,
  RECOIL_SELECTED_ACCOUNT_STATE,
  GCSP_OPP_VIEW,
  CURRENT_USER,
  ACCOUNT_LIST,
  GCSP_ACTIVE_TAB_STATE,
  ACTIVE_TAB_GCSP,
  RECOIL_ALL_ACCOUNTS_QUARTER_STATE,
  GCSP_PAST_OPP_VIEW,
  PURSUIT_LEADER_TABLE_ROW_DATA,
  DASHBOARD_PROFILE_DETAILS,
  SUMMARY_DRAWER_TOGGLE,
  SYSTEM_DATE_TIME,
  GCSP_ROLLING_JUDGE_DATA,
  NOW_NEXT_BEYOND_SIDEBAR_DATA_STATE,
  ALL_MONTH_DATA,
  NEXT_BUTTON_ACTIVE,
  OPERATING_SYSTEM,
  REFRESH_PL_SIDEBAR_DATA,
  TRIGGER_UPDATE_PL_SIDEBAR_DATA,
  PL_SIDEBAR_UPDATE_OPP_PAYLOAD,
  SIDEBAR_EXPAND_COLLAPSE_STATE,
  LOADING_MODAL_STATE
} from './recoilKeys';

export const PL_Commit_State = atom({
  key: PL_COMMIT,
  default: {},
});

export const Recoil_Quarter_State = atom({
  key: QUARTER_INFO,
  default: null,
});

export const Year_Wise_Data_State = atom({
  key: YEAR_WISE_DATA,
  default: {},
});

export const Quaterly_OP_Details_State = atom({
  key: QUARTERLY_OP_DETAILS,
  default: [],
});

export const Modal_Trigger_State = atom({
  key: MODAL_TRIGGER,
  default: false,
});

export const Privacy_Modal_State = atom({
  key: PRIVACY_MODAL,
  default: true,
});

export const Pl_Opps_Details_Modal_State = atom({
  key: PL_OPPS_DETAILS_MODAL,
  default: false,
});

export const Gcsp_Opps_Details_Modal_State = atom({
  key: GCSP_OPPS_DETAILS_MODAL,
  default: false,
});

export const Pl_Comment_Modal_State = atom({
  key: PL_COMMENT_MODAL,
  default: false,
});

export const Gcsp_Comment_Modal_State = atom({
  key: GCSP_COMMENT_MODAL,
  default: false,
});

export const Pl_Submit_Success_Modal_State = atom({
  key: PL_SUBMIT_SUCCESS_MODAL,
  default: false,
});

export const Pl_Failure_Modal_State = atom({
  key: PL_FAILURE_CONFIRMATION_MODAL,
  default: false,
});

export const Pl_Opps_Name_Details_Warning_Modal_State = atom({
  key: PL_OPPS_NAME_DETAILS_WARNING_MODAL,
  default: false,
});

export const Gcsp_Opps_Details_Warning_Modal_State = atom({
  key: GCSP_OPPS_DETAILS_WARNING_MODAL,
  default: false,
});

export const Pl_Comment_Warning_Modal_State = atom({
  key: PL_COMMENT_WARNING_MODAL,
  default: false,
});

export const Gcsp_Comment_Warning_Modal_State = atom({
  key: GCSP_COMMENT_WARNING_MODAL,
  default: false,
});

export const Gcsp_Opp_View_State = atom({
  key: GCSP_OPP_VIEW,
  default: [],
});

export const Recoil_Gcsp_Quarter_State = atom({
  key: GCSP_QUARTER_INFO,
  default: null,
});

export const Recoil_Selected_Account_State = atom({
  key: RECOIL_SELECTED_ACCOUNT_STATE,
  default: null,
});

export const Current_User = atom({
  key: CURRENT_USER,
  default: null,
});

export const Gcsp_Active_Tab_State = atom({
  key: 'GCSP_ACTIVE_TAB_STATE',
  default: 'quarter',
});

export const Active_Tab_Gcsp = atom({
  key: 'ACTIVE_TAB_GCSP',
  default: '0',
});

export const Account_List = atom({
  key: ACCOUNT_LIST,
  default: null,
});

export const Recoil_All_Accounts_Quarter_State = atom({
  key: RECOIL_ALL_ACCOUNTS_QUARTER_STATE,
  default: null,
});

export const Gcsp_Past_Opp_View_State = atom({
  key: GCSP_PAST_OPP_VIEW,
  default: [],
});

export const Dashboard_Profile_Details_State = atom({
  key: DASHBOARD_PROFILE_DETAILS,
  default: [],
});

export const PursuitLeaderTableRowDataState = atom({
  key: PURSUIT_LEADER_TABLE_ROW_DATA,
  default: [],
});

export const Recoil_Summary_Drawer_Toggle = atom({
  key: SUMMARY_DRAWER_TOGGLE,
  default: null,
});

export const System_Date_Time_State = atom({
  key: SYSTEM_DATE_TIME,
  default: null,
});

export const Now_Next_Beyond_Sidebar_Data_State = atom({
  key: NOW_NEXT_BEYOND_SIDEBAR_DATA_STATE,
  default: null,
});

export const All_Month_Data_State = atom({
  key: ALL_MONTH_DATA,
  default: [
    {
      Missed: null,
      Committed: null,
      Not_Committed: null,
      Total_Forecasted: null,
      Your_Judge: null,
      Total_Commit: null,
    },
    {
      Missed: null,
      Committed: null,
      Not_Committed: null,
      Total_Forecasted: null,
      Your_Judge: null,
      Total_Commit: null,
    },
    {
      Missed: null,
      Committed: null,
      Not_Committed: null,
      Total_Forecasted: null,
      Your_Judge: null,
      Total_Commit: null,
    },
  ],
});

export const Next_Button_Active_State = atom({
  key: NEXT_BUTTON_ACTIVE,
  default: false,
});

export const Operating_System_State = atom({
  key: OPERATING_SYSTEM,
  default: null,
});

export const Refresh_Pl_Sidebar_Data = atom({
  key: REFRESH_PL_SIDEBAR_DATA,
  default: false,
});

export const Trigger_Update_Pl_Sidebar_Data = atom({
  key: TRIGGER_UPDATE_PL_SIDEBAR_DATA,
  default: false,
});

export const Pl_Sidebar_Update_Opp_Payload = atom({
  key: PL_SIDEBAR_UPDATE_OPP_PAYLOAD,
  default: null,
});

export const SidebarExpandCollapseState = atom({
  key: SIDEBAR_EXPAND_COLLAPSE_STATE,
  default: true,
});

export const Loading_Modal_State = atom({
  key: LOADING_MODAL_STATE,
  default: false,
});
